import React from 'react';
import styled from 'styled-components';
import Organization from './renderOrganization';
import OrganizationDetails from './OrganizationDetails';
import Logo from './OrganizationDetails/logo';
import Image from './OrganizationDetails/image';
import OrganizationName from './OrganizationDetails/organizationName';
import OrganizationAddress from './OrganizationDetails/organizationAddress';
import RoleDetails from './RoleDetails';
import JobTitle from './RoleDetails/jobTitle';
import RoleDescription from './RoleDetails/roleDescription';
import setSelectionOnMouseDrag from './utils/setSelectionOnMouseDrag';
import renderDict from './utils/renderDict';
import DateComponent from './RoleDetails/date';
import DateComponentCoverLetter from './RoleDetails/coverLetterDate';
import placeholders from './placeholders';
import RoleScore from './RoleDetails/roleScore';
import ArrayItem from './ArrayItems';
import InputNode from './Input';
import { universityEditorSectionRestriction } from '../../../../../../../../utility/universityRestrictions';
import customPlaceholders from '../../../../../../../../utility/universityPolicies/customPlaceholders';

const Para = styled.div`
  user-select: none;
  visibility: hidden;
  height: 0;
`;

const renderBlock = (
  props,
  editor,
  next,
  formatType,
  setDateRef,
  statusBarRef,
  mostUsedToolSetRef,
  isTitleEditing,
  sectionKey,
  selectedPlan,
  universityPlan,
  saveDocument,
) => /* showError */ {
  let showImage = true;
  if (
    !universityEditorSectionRestriction('image', formatType, universityPlan)
  ) {
    showImage = false;
  }
  const { node, attributes, children, isFocused } = props;
  const { type } = node;
  setSelectionOnMouseDrag(editor /* showError */);
  const renderDictType = renderDict[type];

  switch (renderDictType) {
    case 'organization': {
      return (
        <Organization
          nodeProps={props}
          editor={editor}
          mostUsedToolSetRef={mostUsedToolSetRef}
          statusBarRef={statusBarRef}
        >
          {children}
        </Organization>
      );
    }

    case 'organization_details': {
      return (
        <OrganizationDetails showImage={showImage} nodeProps={props}>
          {children}
        </OrganizationDetails>
      );
    }

    case 'organization_logo': {
      return (
        <Logo showImage={showImage} nodeProps={props}>
          {children}
        </Logo>
      );
    }

    case 'organization_image': {
      return (
        <Image showImage={showImage} nodeProps={props} editor={editor}>
          {children}
        </Image>
      );
    }

    case 'organization_name': {
      return (
        <OrganizationName nodeProps={props} isFocused={isFocused}>
          {children}
        </OrganizationName>
      );
    }

    case 'organization_address': {
      return (
        <OrganizationAddress nodeProps={props} isFocused={isFocused}>
          {children}
        </OrganizationAddress>
      );
    }

    case 'organization_role_details': {
      return (
        <RoleDetails
          nodeProps={props}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
        >
          {children}
        </RoleDetails>
      );
    }

    case 'organization_role_title': {
      return (
        <JobTitle
          nodeProps={props}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
        >
          {children}
        </JobTitle>
      );
    }

    case 'organization_role_date': {
      return (
        <DateComponent
          nodeProps={props}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
          formatType={formatType}
          setDateRef={setDateRef}
          universityPlan={universityPlan}
        >
          {children}
        </DateComponent>
      );
    }

    case 'cover_letter_date': {
      return (
        <DateComponentCoverLetter
          nodeProps={props}
          placeHolder={placeholders[type]}
          formatType={formatType}
          setDateRef={setDateRef}
        >
          {children}
        </DateComponentCoverLetter>
      );
    }

    case 'organization_role_score': {
      return <RoleScore universityPlan={universityPlan} nodeProps={props} />;
    }

    case 'organization_role_editable_div': {
      return (
        <RoleDescription
          nodeProps={props}
          formatType={formatType}
          isTitleEditing={isTitleEditing}
          universityPlan={universityPlan}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
          sectionKey={sectionKey}
          saveDocument={saveDocument}
        >
          {children}
        </RoleDescription>
      );
    }

    case 'empty_paragraph': {
      return <Para {...attributes}>{children}</Para>;
    }

    case 'array_item': {
      return (
        <ArrayItem
          formatType={formatType}
          nodeProps={props}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
          statusBarRef={statusBarRef}
          mostUsedToolSetRef={mostUsedToolSetRef}
          sectionKey={sectionKey}
        >
          {children}
        </ArrayItem>
      );
    }

    case 'input': {
      return (
        <InputNode
          nodeProps={props}
          placeHolder={customPlaceholders({
            sectionKey,
            formatType,
            type,
            selectedPlan,
            universityPlan,
          })}
          formatType={formatType}
        >
          {children}
        </InputNode>
      );
    }
    case 'list_item': {
      return <li {...attributes}>{children}</li>;
    }

    case 'unordered_list': {
      return <ul {...attributes}>{children}</ul>;
    }

    case 'paragraph': {
      return <p {...attributes}>{children}</p>;
    }

    default:
      return next();
  }
};

export default renderBlock;
